import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import MenuItem from "@mui/material/MenuItem";
import { useStyles } from "./MenuItem.styles.js";
const MenuItem_MenuItem = (t0)=>{
    const $ = c(6);
    const { children, onClick, disabled, testId } = t0;
    const { classes } = useStyles();
    const t1 = disabled ? void 0 : onClick;
    let t2;
    if ($[0] !== children || $[1] !== classes.menuItem || $[2] !== disabled || $[3] !== t1 || $[4] !== testId) {
        t2 = /*#__PURE__*/ jsx(MenuItem, {
            disabled: disabled,
            "data-testid": testId,
            onClick: t1,
            className: classes.menuItem,
            children: children
        });
        $[0] = children;
        $[1] = classes.menuItem;
        $[2] = disabled;
        $[3] = t1;
        $[4] = testId;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
export { MenuItem_MenuItem as MenuItem };
